module.exports = __webpack_public_path__ + "static/img/case_1.3ecb74ec.jpg";